export const STATUS_NONE = -1;
export const STATUS_APPROVED = 0;
export const STATUS_PARTIAL_APPROVED = 1;
export const STATUS_NOT_APPROVED = 2;
export const STATUS_WARNING = 3;
export const STATUS_ERROR = 4;
export const STATUS_APPROVED_LEVEL1 = 5;
export const STATUS_APPROVED_LEVEL2 = 6;
export const STATUS_NOT_APPROVED_LEVEL1 = 7;
export const STATUS_NOT_APPROVED_LEVEL2 = 8;